<template>
  <header class="shell-header">
    <label class="search-box">
      <!-- <i class="el-icon-search"></i> -->
      <img class="search-icon" src="../../assets/image/search.png" alt="搜索" />
      <input :value="searchKeyword" type="text" :placeholder="searchPlaceholder" @input="onSearchInput" />
    </label>

    <div class="header-actions">
      <button class="action-button" type="button" aria-label="复制" @click="onCopyClick">
        <i class="el-icon-paperclip"></i>
      </button>

      <el-dropdown trigger="click" class="settings-dropdown" @command="onUserMenuCommand">
        <button class="action-button" type="button" aria-label="系统设置" aria-haspopup="true">
          <i class="el-icon-setting"></i>
          <!-- <img class="seeting-icon" src="../../assets/image/seeting.png" alt="设置" /> -->
        </button>
        <el-dropdown-menu slot="dropdown" class="shell-header-dropdown">
          <el-dropdown-item command="modifyUserInfo">修改信息</el-dropdown-item>
          <!-- <el-dropdown-item divided command="logout">退出</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>

      <head-image class="user-avatar shell-header-avatar" :id="mine.id" :size="avatarSize" radius="9999px"
        :url="avatarUrlResolved" :name="mine.nickName" :isShowUserInfo="false" @click.native="onAvatarClick" />
    </div>
  </header>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "ShellHeader",
  components: {
    HeadImage
  },
  model: {
    prop: "searchKeyword",
    event: "update:searchKeyword"
  },
  props: {
    searchKeyword: {
      type: String,
      default: ""
    },
    searchPlaceholder: {
      type: String,
      default: "搜索会话..."
    },
    avatarSize: {
      type: Number,
      default: 32
    },
    /** 可选：覆盖头像 URL；不传则用当前登录用户 headImage / headImageThumb */
    avatarSrc: {
      type: String,
      default: ""
    }
  },
  computed: {
    mine() {
      return this.userStore.userInfo;
    },
    avatarUrlResolved() {
      const s = this.avatarSrc;
      if (s != null && String(s).trim() !== "") {
        return String(s).trim();
      }
      const u = this.userStore.userInfo || {};
      return u.headImage || u.headImageThumb || "";
    }
  },
  methods: {
    onSearchInput(e) {
      const v = e && e.target ? e.target.value : "";
      this.$emit("update:searchKeyword", v);
    },
    onCopyClick() {
      // this.$eventBus.$emit("openCopyUrl", this.userStore.userInfo.serviceUrl);
      this.$emit("copy-click");
    },

    onUserMenuCommand(command) {
      this.$emit("user-menu-command", command);
    },

    onAvatarClick() {
      this.$emit("avatar-click");
    }
  }
};
</script>

<style lang="scss" scoped>
.shell-header {
  height: 55px;
  min-height: 55px;
  display: flex;
  align-items: center;
  gap: 16px;
  gap: 250px;
  padding: 0 16px;
  background-color: rgba(255, 255, 255, 0.8);
  border-bottom: 1px solid rgba(226, 232, 240, 0.5);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  z-index: 999;
  box-sizing: border-box;
}

.search-box {
  flex: 1;
  // max-width: 620px;
  // max-width: 712px;
  height: 38px;
  display: flex;
  align-items: center;
  //  gap: 10px;
  padding: 0 14px;
  border-radius: 999px;
  background: #eff1f2;
  border: 1px solid transparent;

  .search-icon {
    width: 18.5px;
    height: 10.5px;
    object-fit: contain;
  }

  input {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    color: #6b7280;
    font-size: 14px;
  }
}

.header-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-button,
.user-avatar {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 9999px;
  background: #fff;
  color: #64748b;

  &:hover {
    color: #000dff;
  }

  // border: 1px solid rgba(68, 165, 255, 0.2);
  // box-shadow: inset 0 0 0 1px rgba(224, 229, 238, 0.95);
}

.seeting-icon {
  width: 20px;
  height: 20px;
}

.action-button {
  cursor: pointer;
  font-size: 16px;
}

.user-avatar {
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.95), 0 8px 18px rgba(41, 63, 122, 0.12);
}

.settings-dropdown {
  display: inline-flex;
}
</style>
